'use client'

import { createContext, type PropsWithChildren, useContext } from 'react'

import type { CookieParams } from './types.ts'

const CookieParamsContext = createContext<CookieParams>({})

export const useCookieParams = () => useContext(CookieParamsContext)

export const CookieParamsProvider = ({
  children,
  params,
}: PropsWithChildren<{ params: CookieParams }>) => {
  return (
    <CookieParamsContext.Provider value={params}>
      {children}
    </CookieParamsContext.Provider>
  )
}
